import React, { Component } from 'react';
import formDataSchema from '../../../schema/tat-report';
import moment, { defaultFormatUtc } from 'moment';
import { CSVLink } from "react-csv";
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Switch, Spin, Tooltip, Modal, Button, notification, Pagination } from 'antd';
import DateRange from '../../../components/FormComponent/DateRange';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
const $ = require('jquery');
const {homepage} = networkList;
class Documents_Report extends Component {
    csvLink = React.createRef()

    constructor(props) {
        super(props);
        this.state = {
            date: '',
            appTime: [],
            headding: null,
            postdata: {},
            formData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItemsCount: 0,
            isLoading: false,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            'downloadtbody': [],
            search: ""
        };
    }

    componentDidMount() {
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState(({ 'formData': formSchema['feilds'] }), () => {
            this.fetchData(this.state.formData);
            // this.renderHead();
            this.loadPage()
        })

    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({
                    'loadding': true, dateTo: moment().format('YYYY-MM-DD'),
                    activePage: 1,
                    totalItemsCount: 0,
                    dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
                }), () => {
                    this.loadPage();
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    fetchData(fetchData) {
        var payload = {
            "unit_id": null,
            "from_date": this.state.dateFrom,
            "to_date": this.state.dateTo,
            "page": this.state.activePage
        }
        console.log('payload:', payload);
    }

    loadPage = (isDatefilter = false) => {
        try {
            let { activePage } = this.state;
            let { slug } = this.props.match.params;
            const { getDocumentsReport } = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            this.setState({ downloadStatus: 0 })
            let user_data = JSON.parse(localStorage.getItem('user_data'))
            let unit = user_data['unitid']
            switch (unit) {
                case 'UN0':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '1',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '1_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '2',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '2_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '3',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '3_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '4',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '4_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '5',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '5_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '6',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '6_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '7',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '7_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '8',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '8_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '9',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '9_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '10',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '10_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '11',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '11_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '12',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '12_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '13',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '13_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '14',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '14_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '15',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '15_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '16',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '16_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '17',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '17_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '18',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '18_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '19',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '19_uploaded_date',
                            'label': 'Uploaded Date'
                        },
                        {
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },
                        {
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN1': 
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '1',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '1_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '2',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '2_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '3',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '3_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '4',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '4_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '5',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '5_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '6',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '6_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '7',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '7_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '8',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '8_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '9',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '9_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '10',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '10_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '11',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '11_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '12',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '12_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '13',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '13_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '14',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '14_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '15',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '15_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '16',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '16_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '17',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '17_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '18',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '18_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '19',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '19_uploaded_date',
                            'label': 'Uploaded Date'
                        },
                        {
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },
                        {
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN2':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        },{
                            "key": '20',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '20_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '21',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '21_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '22',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '22_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '23',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '23_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '24',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '24_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '25',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '25_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '26',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '26_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '27',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '27_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '28',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '28_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '29',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '29_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '30',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '30_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '31',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '31_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '32',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '32_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '33',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '33_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '34',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '34_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '35',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '35_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '36',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '36_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '37',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '37_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '38',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '38_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN3':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        },{
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '39',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '39_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '40',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '40_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '41',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '41_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '42',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '42_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '43',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '43_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '44',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '44_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '45',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '45_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '46',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '46_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '47',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '47_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '48',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '48_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '49',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '49_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '50',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '50_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '51',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '51_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '52',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '52_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '53',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '53_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '54',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '54_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '55',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '55_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '56',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '56_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '57',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '57_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN11':
                        tableHead = [
                            {
                                "key": 'ip_no',
                                'label': 'IP Number'
                            }, {
                                "key": 'umr_no',
                                'label': 'UMR Number'
                            }, {
                                "key": 'patient_name',
                                'label': 'Patient Name'
                            }, {
                                "key": 'phone_number',
                                'label': 'Phone Number'
                            },{
                                "key": 'doctor_name',
                                'label': 'Doctor Name'
                            }, {
                                "key": 'department_name',
                                'label': 'Department Name'
                            }, {
                                "key": 'admission_date',
                                'label': 'Admission Date'
                            }, {
                                "key": '58',
                                'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                            }, {
                                "key": '58_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '59',
                                'label': 'Current Insurance Card/Policy Copy'
                            }, {
                                "key": '59_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '60',
                                'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                            }, {
                                "key": '60_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '61',
                                'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                            }, {
                                "key": '61_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '62',
                                'label': 'Employee ID Card (For Corporate Policies)'
                            }, {
                                "key": '62_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '63',
                                'label': 'Current OP Investigation Reports'
                            }, {
                                "key": '63_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '64',
                                'label': 'Current OP Prescription Signed By Doctor'
                            }, {
                                "key": '64_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '65',
                                'label': 'Past Investigation Reports'
                            }, {
                                "key": '65_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '66',
                                'label': 'Previous Discharge Summary (If Applicable)'
                            }, {
                                "key": '66_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '67',
                                'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                            }, {
                                "key": '67_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '68',
                                'label': 'Passport Size Photo Of Policy Holder'
                            }, {
                                "key": '68_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '69',
                                'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                            }, {
                                "key": '69_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '70',
                                'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                            }, {
                                "key": '70_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '71',
                                'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                            }, {
                                "key": '71_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '72',
                                'label': 'MLC/FIR (If Applicable)'
                            }, {
                                "key": '72_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '73',
                                'label': 'KYC Form (Issued By Hospital)'
                            }, {
                                "key": '73_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '74',
                                'label': 'Initial Assessment Form (If Applicable)'
                            }, {
                                "key": '74_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '75',
                                'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                            }, {
                                "key": '75_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '76',
                                'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                            }, {
                                "key": '76_uploaded_date',
                                'label': 'Uploaded Date'
                            },{
                                "key": '1st_document_upload _time',
                                'label': '1st document upload time'
                            },
                            {
                                "key": 'last_document_upload_time',
                                'label': ' last document upload time'
                            },{
                                "key": 'rn_preauth_requested_time',
                                'label': 'Pre-Auth Requested Time'
                            }
                        ]
                        break; 
                case 'UN10':
                            tableHead = [
                                {
                                    "key": 'ip_no',
                                    'label': 'IP Number'
                                }, {
                                    "key": 'umr_no',
                                    'label': 'UMR Number'
                                }, {
                                    "key": 'patient_name',
                                    'label': 'Patient Name'
                                }, {
                                    "key": 'phone_number',
                                    'label': 'Phone Number'
                                },{
                                    "key": 'doctor_name',
                                    'label': 'Doctor Name'
                                }, {
                                    "key": 'department_name',
                                    'label': 'Department Name'
                                }, {
                                    "key": 'admission_date',
                                    'label': 'Admission Date'
                                }, {
                                    "key": '77',
                                    'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                }, {
                                    "key": '77_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '78',
                                    'label': 'Current Insurance Card/Policy Copy'
                                }, {
                                    "key": '78_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '79',
                                    'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                                }, {
                                    "key": '79_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '80',
                                    'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                }, {
                                    "key": '80_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '81',
                                    'label': 'Employee ID Card (For Corporate Policies)'
                                }, {
                                    "key": '81_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '82',
                                    'label': 'Current OP Investigation Reports'
                                }, {
                                    "key": '82_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '83',
                                    'label': 'Current OP Prescription Signed By Doctor'
                                }, {
                                    "key": '83_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '84',
                                    'label': 'Past Investigation Reports'
                                }, {
                                    "key": '84_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '85',
                                    'label': 'Previous Discharge Summary (If Applicable)'
                                }, {
                                    "key": '85_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '86',
                                    'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                                }, {
                                    "key": '86_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '87',
                                    'label': 'Passport Size Photo Of Policy Holder'
                                }, {
                                    "key": '87_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '88',
                                    'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                                }, {
                                    "key": '88_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '89',
                                    'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                                }, {
                                    "key": '89_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '90',
                                    'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                                }, {
                                    "key": '90_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '91',
                                    'label': 'MLC/FIR (If Applicable)'
                                }, {
                                    "key": '91_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '92',
                                    'label': 'KYC Form (Issued By Hospital)'
                                }, {
                                    "key": '92_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '93',
                                    'label': 'Initial Assessment Form (If Applicable)'
                                }, {
                                    "key": '93_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '94',
                                    'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                                }, {
                                    "key": '94_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '95',
                                    'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                                }, {
                                    "key": '95_uploaded_date',
                                    'label': 'Uploaded Date'
                                },{
                                    "key": '1st_document_upload _time',
                                    'label': '1st document upload time'
                                },
                                {
                                    "key": 'last_document_upload_time',
                                    'label': ' last document upload time'
                                },{
                                    "key": 'rn_preauth_requested_time',
                                    'label': 'Pre-Auth Requested Time'
                                }
                            ]
                            break;  
                case 'UN14':
                    tableHead = [
                                    {
                                        "key": 'ip_no',
                                        'label': 'IP Number'
                                    }, {
                                        "key": 'umr_no',
                                        'label': 'UMR Number'
                                    }, {
                                        "key": 'patient_name',
                                        'label': 'Patient Name'
                                    }, {
                                        "key": 'phone_number',
                                        'label': 'Phone Number'
                                    },{
                                        "key": 'doctor_name',
                                        'label': 'Doctor Name'
                                    }, {
                                        "key": 'department_name',
                                        'label': 'Department Name'
                                    }, {
                                        "key": 'admission_date',
                                        'label': 'Admission Date'
                                    }, {
                                        "key": '96',
                                        'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                    }, {
                                        "key": '96_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '97',
                                        'label': 'Current Insurance Card/Policy Copy'
                                    }, {
                                        "key": '97_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '98',
                                        'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                                    }, {
                                        "key": '98_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '99',
                                        'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                    }, {
                                        "key": '99_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '100',
                                        'label': 'Employee ID Card (For Corporate Policies)'
                                    }, {
                                        "key": '100_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '101',
                                        'label': 'Current OP Investigation Reports'
                                    }, {
                                        "key": '101_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '102',
                                        'label': 'Current OP Prescription Signed By Doctor'
                                    }, {
                                        "key": '102_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '103',
                                        'label': 'Past Investigation Reports'
                                    }, {
                                        "key": '103_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '104',
                                        'label': 'Previous Discharge Summary (If Applicable)'
                                    }, {
                                        "key": '104_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '105',
                                        'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                                    }, {
                                        "key": '105_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '106',
                                        'label': 'Passport Size Photo Of Policy Holder'
                                    }, {
                                        "key": '106_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '107',
                                        'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                                    }, {
                                        "key": '107_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '108',
                                        'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                                    }, {
                                        "key": '108_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '109',
                                        'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                                    }, {
                                        "key": '109_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '110',
                                        'label': 'MLC/FIR (If Applicable)'
                                    }, {
                                        "key": '110_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '111',
                                        'label': 'KYC Form (Issued By Hospital)'
                                    }, {
                                        "key": '111_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '112',
                                        'label': 'Initial Assessment Form (If Applicable)'
                                    }, {
                                        "key": '112_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '113',
                                        'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                                    }, {
                                        "key": '113_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '114',
                                        'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                                    }, {
                                        "key": '114_uploaded_date',
                                        'label': 'Uploaded Date'
                                    },{
                                        "key": '1st_document_upload _time',
                                        'label': '1st document upload time'
                                    },
                                    {
                                        "key": 'last_document_upload_time',
                                        'label': ' last document upload time'
                                    },{
                                        "key": 'rn_preauth_requested_time',
                                        'label': 'Pre-Auth Requested Time'
                                    }
                                ]
                                break;  
                case 'UN4':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        },{
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '96',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '96_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '97',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '97_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '98',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '98_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '99',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '99_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '100',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '100_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '101',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '101_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '102',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '102_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '103',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '103_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '104',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '104_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '105',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '105_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '106',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '106_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '107',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '107_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '108',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '108_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '109',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '109_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '110',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '110_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '111',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '111_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '112',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '112_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '113',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '113_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '114',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '114_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;  
                case 'UN9': 
                tableHead = [
                    {
                        "key": 'ip_no',
                        'label': 'IP Number'
                    }, {
                        "key": 'umr_no',
                        'label': 'UMR Number'
                    }, {
                        "key": 'patient_name',
                        'label': 'Patient Name'
                    }, {
                        "key": 'phone_number',
                        'label': 'Phone Number'
                    },{
                        "key": 'doctor_name',
                        'label': 'Doctor Name'
                    }, {
                        "key": 'department_name',
                        'label': 'Department Name'
                    }, {
                        "key": 'admission_date',
                        'label': 'Admission Date'
                    }, {
                        "key": '96',
                        'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                    }, {
                        "key": '96_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '97',
                        'label': 'Current Insurance Card/Policy Copy'
                    }, {
                        "key": '97_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '98',
                        'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                    }, {
                        "key": '98_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '99',
                        'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                    }, {
                        "key": '99_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '100',
                        'label': 'Employee ID Card (For Corporate Policies)'
                    }, {
                        "key": '100_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '101',
                        'label': 'Current OP Investigation Reports'
                    }, {
                        "key": '101_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '102',
                        'label': 'Current OP Prescription Signed By Doctor'
                    }, {
                        "key": '102_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '103',
                        'label': 'Past Investigation Reports'
                    }, {
                        "key": '103_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '104',
                        'label': 'Previous Discharge Summary (If Applicable)'
                    }, {
                        "key": '104_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '105',
                        'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                    }, {
                        "key": '105_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '106',
                        'label': 'Passport Size Photo Of Policy Holder'
                    }, {
                        "key": '106_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '107',
                        'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                    }, {
                        "key": '107_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '108',
                        'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                    }, {
                        "key": '108_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '109',
                        'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                    }, {
                        "key": '109_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '110',
                        'label': 'MLC/FIR (If Applicable)'
                    }, {
                        "key": '110_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '111',
                        'label': 'KYC Form (Issued By Hospital)'
                    }, {
                        "key": '111_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '112',
                        'label': 'Initial Assessment Form (If Applicable)'
                    }, {
                        "key": '112_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '113',
                        'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                    }, {
                        "key": '113_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '114',
                        'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                    }, {
                        "key": '114_uploaded_date',
                        'label': 'Uploaded Date'
                    },{
                        "key": '1st_document_upload _time',
                        'label': '1st document upload time'
                    },
                    {
                        "key": 'last_document_upload_time',
                        'label': ' last document upload time'
                    },{
                        "key": 'rn_preauth_requested_time',
                        'label': 'Pre-Auth Requested Time'
                    }
                ]
                break;                           
                default:
                    break;    
            }
            switch (slug) {
                case 'documents-report':

                    this.setState((state) => ({ showFilter: true, tableTitle: 'Documents Report', thead: tableHead, filename: 'Documents-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                        postService(getDocumentsReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                                "export": 0,
                                "page_no": isDatefilter ? 1 : activePage
                            }
                        }).then(res => {
                            console.log('tat report:', res.data);
                            if (res.status) {
                                res.data.map((data, key) => {
                                    let dateArray=[];
                                    Object.keys(data).map((dataKey) => {
                                        if (dataKey === 'token_issue_date') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'checkin_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null
                                        }
                                        if (dataKey === 'checkout_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD MMM YYYY LT') : null

                                        }
                                        // if (dataKey === 'rn_preauth_requested_time') {
                                        //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm:ss') : null
                                            
                                        // }
                                        if(dataKey!=='counselling_id' && res.data[key][dataKey]!==null && dataKey!=='admission_date' && dataKey!=='rn_preauth_requested_time'){
                                            let x = new Date(res.data[key][dataKey]);
                                            if (x instanceof Date && !isNaN(x)) {
                                                dateArray.push(res.data[key][dataKey]);
                                                if(dateArray.length>0)
                                                    {
                                                        const minDate = dateArray.reduce((acc,date)=>{return acc&&new Date(acc)<new Date(date)?acc:date},'')
                                                      const maxDate = dateArray.reduce((acc,date)=>{return acc&&new Date(acc)>new Date(date)?acc:date},'')
                                                       res.data[key]['1st_document_upload _time']=minDate?moment(minDate).format('DD-MM-YYYY HH:mm:ss'):null;
                                                       res.data[key]['last_document_upload_time']=maxDate?moment(maxDate).format('DD-MM-YYYY HH:mm:ss'):null;
                                                    }
                                            }
                                        }
                                        
                                    })
                                })
                                this.setState((state) => ({ tbody: res.data, totalItemsCount: res.total_items, data: data, loadding: false }));
                                // enable downloadbtn after 2sec
                                setTimeout(function () {
                                    This.setState((state) => ({ downloadStatus: 1 }))
                                }, 2000);
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }

                            }
                        });
                    });

                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
        }
    }
    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        this.setState(({
            activePage: 1,
            totalItemsCount: 0, doctor_id: formFeilds[0].value, payment_type: parseInt(formFeilds[1].value), searchwords: formFeilds[2].value
        }), () => {
            this.loadPage()
        })
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            tbody: [],
            activePage: page,
        }), () => {
            this.loadPage();
        })
    }
    search = () => {
        // let {search}=this.state
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage();
        })
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })
    }
    downloadFile = (isDatefilter = false) => {
        try {
            let { activePage } = this.state;
            let { slug } = this.props.match.params;
            const { getDocumentsReport } = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            let user_data = JSON.parse(localStorage.getItem('user_data'))
            let unit = user_data['unitid']
            // switch (unit) {
            //     case 'UN1':
            //         tableHead = [
            //             {
            //                 "key": 'ip_no',
            //                 'label': 'IP Number'
            //             }, {
            //                 "key": 'umr_no',
            //                 'label': 'UMR Number'
            //             }, {
            //                 "key": 'patient_name',
            //                 'label': 'Patient Name'
            //             }, {
            //                 "key": 'phone_number',
            //                 'label': 'Phone Number'
            //             }, {
            //                 "key": 'doctor_name',
            //                 'label': 'Doctor Name'
            //             }, {
            //                 "key": 'department_name',
            //                 'label': 'Department Name'
            //             }, {
            //                 "key": 'admission_date',
            //                 'label': 'Admission Date'
            //             },{
            //                 "key": '1',
            //                 'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '1_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '2',
            //                 'label': 'Current Insurance Card/Policy Copy'
            //             }, {
            //                 "key": '2_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '3',
            //                 'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //             }, {
            //                 "key": '3_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '4',
            //                 'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '4_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '5',
            //                 'label': 'Employee ID Card (For Corporate Policies)'
            //             }, {
            //                 "key": '5_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '6',
            //                 'label': 'Current OP Investigation Reports'
            //             }, {
            //                 "key": '6_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '7',
            //                 'label': 'Current OP Prescription Signed By Doctor'
            //             }, {
            //                 "key": '7_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '8',
            //                 'label': 'Past Investigation Reports'
            //             }, {
            //                 "key": '8_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '9',
            //                 'label': 'Previous Discharge Summary (If Applicable)'
            //             }, {
            //                 "key": '9_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '10',
            //                 'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //             }, {
            //                 "key": '10_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '11',
            //                 'label': 'Passport Size Photo Of Policy Holder'
            //             }, {
            //                 "key": '11_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '12',
            //                 'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //             }, {
            //                 "key": '12_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '13',
            //                 'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //             }, {
            //                 "key": '13_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '14',
            //                 'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //             }, {
            //                 "key": '14_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '15',
            //                 'label': 'MLC/FIR (If Applicable)'
            //             }, {
            //                 "key": '15_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '16',
            //                 'label': 'KYC Form (Issued By Hospital)'
            //             }, {
            //                 "key": '16_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '17',
            //                 'label': 'Initial Assessment Form (If Applicable)'
            //             }, {
            //                 "key": '17_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '18',
            //                 'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //             }, {
            //                 "key": '18_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '19',
            //                 'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //             }, {
            //                 "key": '19_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             },{
            //                 "key": '1st_document_upload _time',
            //                 'label': '1st document upload time'
            //             },
            //             {
            //                 "key": 'last_document_upload_time',
            //                 'label': ' last document upload time'
            //             },{
            //                 "key": 'rn_preauth_requested_time',
            //                 'label': 'Pre-Auth Requested Time'
            //             }
            //         ]
            //         break;
            //     case 'UN2':
            //         tableHead = [
            //             {
            //                 "key": 'ip_no',
            //                 'label': 'IP Number'
            //             }, {
            //                 "key": 'umr_no',
            //                 'label': 'UMR Number'
            //             }, {
            //                 "key": 'patient_name',
            //                 'label': 'Patient Name'
            //             }, {
            //                 "key": 'phone_number',
            //                 'label': 'Phone Number'
            //             }, {
            //                 "key": 'doctor_name',
            //                 'label': 'Doctor Name'
            //             }, {
            //                 "key": 'department_name',
            //                 'label': 'Department Name'
            //             }, {
            //                 "key": 'admission_date',
            //                 'label': 'Admission Date'
            //             },{
            //                 "key": '20',
            //                 'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '20_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '21',
            //                 'label': 'Current Insurance Card/Policy Copy'
            //             }, {
            //                 "key": '21_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '22',
            //                 'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //             }, {
            //                 "key": '22_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '23',
            //                 'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '23_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '24',
            //                 'label': 'Employee ID Card (For Corporate Policies)'
            //             }, {
            //                 "key": '24_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '25',
            //                 'label': 'Current OP Investigation Reports'
            //             }, {
            //                 "key": '25_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '26',
            //                 'label': 'Current OP Prescription Signed By Doctor'
            //             }, {
            //                 "key": '26_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '27',
            //                 'label': 'Past Investigation Reports'
            //             }, {
            //                 "key": '27_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '28',
            //                 'label': 'Previous Discharge Summary (If Applicable)'
            //             }, {
            //                 "key": '28_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '29',
            //                 'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //             }, {
            //                 "key": '29_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '30',
            //                 'label': 'Passport Size Photo Of Policy Holder'
            //             }, {
            //                 "key": '30_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '31',
            //                 'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //             }, {
            //                 "key": '31_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '32',
            //                 'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //             }, {
            //                 "key": '32_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '33',
            //                 'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //             }, {
            //                 "key": '33_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '34',
            //                 'label': 'MLC/FIR (If Applicable)'
            //             }, {
            //                 "key": '34_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '35',
            //                 'label': 'KYC Form (Issued By Hospital)'
            //             }, {
            //                 "key": '35_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '36',
            //                 'label': 'Initial Assessment Form (If Applicable)'
            //             }, {
            //                 "key": '36_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '37',
            //                 'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //             }, {
            //                 "key": '37_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '38',
            //                 'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //             }, {
            //                 "key": '38_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             },
            //             {
            //                 "key": '1st_document_upload _time',
            //                 'label': '1st document upload time'
            //             },
            //             {
            //                 "key": 'last_document_upload_time',
            //                 'label': ' last document upload time'
            //             },{
            //                 "key": 'rn_preauth_requested_time',
            //                 'label': 'Pre-Auth Requested Time'
            //             }
            //         ]
            //         break;
            //     case 'UN3':
            //         tableHead = [
            //             {
            //                 "key": 'ip_no',
            //                 'label': 'IP Number'
            //             }, {
            //                 "key": 'umr_no',
            //                 'label': 'UMR Number'
            //             }, {
            //                 "key": 'patient_name',
            //                 'label': 'Patient Name'
            //             }, {
            //                 "key": 'phone_number',
            //                 'label': 'Phone Number'
            //             },{
            //                 "key": 'doctor_name',
            //                 'label': 'Doctor Name'
            //             }, {
            //                 "key": 'department_name',
            //                 'label': 'Department Name'
            //             }, {
            //                 "key": 'admission_date',
            //                 'label': 'Admission Date'
            //             }, {
            //                 "key": '39',
            //                 'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '39_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '40',
            //                 'label': 'Current Insurance Card/Policy Copy'
            //             }, {
            //                 "key": '40_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '41',
            //                 'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //             }, {
            //                 "key": '41_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '42',
            //                 'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '42_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '43',
            //                 'label': 'Employee ID Card (For Corporate Policies)'
            //             }, {
            //                 "key": '43_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '44',
            //                 'label': 'Current OP Investigation Reports'
            //             }, {
            //                 "key": '44_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '45',
            //                 'label': 'Current OP Prescription Signed By Doctor'
            //             }, {
            //                 "key": '45_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '46',
            //                 'label': 'Past Investigation Reports'
            //             }, {
            //                 "key": '46_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '47',
            //                 'label': 'Previous Discharge Summary (If Applicable)'
            //             }, {
            //                 "key": '47_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '48',
            //                 'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //             }, {
            //                 "key": '48_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '49',
            //                 'label': 'Passport Size Photo Of Policy Holder'
            //             }, {
            //                 "key": '49_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '50',
            //                 'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //             }, {
            //                 "key": '50_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '51',
            //                 'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //             }, {
            //                 "key": '51_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '52',
            //                 'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //             }, {
            //                 "key": '52_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '53',
            //                 'label': 'MLC/FIR (If Applicable)'
            //             }, {
            //                 "key": '53_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '54',
            //                 'label': 'KYC Form (Issued By Hospital)'
            //             }, {
            //                 "key": '54_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '55',
            //                 'label': 'Initial Assessment Form (If Applicable)'
            //             }, {
            //                 "key": '55_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '56',
            //                 'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //             }, {
            //                 "key": '56_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '57',
            //                 'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //             }, {
            //                 "key": '57_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             },
            //             {
            //                 "key": '1st_document_upload _time',
            //                 'label': '1st document upload time'
            //             },
            //             {
            //                 "key": 'last_document_upload_time',
            //                 'label': ' last document upload time'
            //             },{
            //                 "key": 'rn_preauth_requested_time',
            //                 'label': 'Pre-Auth Requested Time'
            //             }
            //         ]
            //         break;
            //     case 'UN11':
            //             tableHead = [
            //                 {
            //                     "key": 'ip_no',
            //                     'label': 'IP Number'
            //                 }, {
            //                     "key": 'umr_no',
            //                     'label': 'UMR Number'
            //                 }, {
            //                     "key": 'patient_name',
            //                     'label': 'Patient Name'
            //                 }, {
            //                     "key": 'phone_number',
            //                     'label': 'Phone Number'
            //                 },{
            //                     "key": 'doctor_name',
            //                     'label': 'Doctor Name'
            //                 }, {
            //                     "key": 'department_name',
            //                     'label': 'Department Name'
            //                 }, {
            //                     "key": 'admission_date',
            //                     'label': 'Admission Date'
            //                 }, {
            //                     "key": '58',
            //                     'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //                 }, {
            //                     "key": '58_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '59',
            //                     'label': 'Current Insurance Card/Policy Copy'
            //                 }, {
            //                     "key": '59_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '60',
            //                     'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //                 }, {
            //                     "key": '60_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '61',
            //                     'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //                 }, {
            //                     "key": '61_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '62',
            //                     'label': 'Employee ID Card (For Corporate Policies)'
            //                 }, {
            //                     "key": '62_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '63',
            //                     'label': 'Current OP Investigation Reports'
            //                 }, {
            //                     "key": '63_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '64',
            //                     'label': 'Current OP Prescription Signed By Doctor'
            //                 }, {
            //                     "key": '64_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '65',
            //                     'label': 'Past Investigation Reports'
            //                 }, {
            //                     "key": '65_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '66',
            //                     'label': 'Previous Discharge Summary (If Applicable)'
            //                 }, {
            //                     "key": '66_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '67',
            //                     'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //                 }, {
            //                     "key": '67_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '68',
            //                     'label': 'Passport Size Photo Of Policy Holder'
            //                 }, {
            //                     "key": '68_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '69',
            //                     'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //                 }, {
            //                     "key": '69_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '70',
            //                     'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //                 }, {
            //                     "key": '70_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '71',
            //                     'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //                 }, {
            //                     "key": '71_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '72',
            //                     'label': 'MLC/FIR (If Applicable)'
            //                 }, {
            //                     "key": '72_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '73',
            //                     'label': 'KYC Form (Issued By Hospital)'
            //                 }, {
            //                     "key": '73_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '74',
            //                     'label': 'Initial Assessment Form (If Applicable)'
            //                 }, {
            //                     "key": '74_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '75',
            //                     'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //                 }, {
            //                     "key": '75_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '76',
            //                     'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //                 }, {
            //                     "key": '76_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 },{
            //                     "key": '1st_document_upload _time',
            //                     'label': '1st document upload time'
            //                 },
            //                 {
            //                     "key": 'last_document_upload_time',
            //                     'label': ' last document upload time'
            //                 },{
            //                     "key": 'rn_preauth_requested_time',
            //                     'label': 'Pre-Auth Requested Time'
            //                 }
            //             ]
            //             break;
            //     case 'UN10':
            //         tableHead = [
            //             {
            //                 "key": 'ip_no',
            //                 'label': 'IP Number'
            //             }, {
            //                 "key": 'umr_no',
            //                 'label': 'UMR Number'
            //             }, {
            //                 "key": 'patient_name',
            //                 'label': 'Patient Name'
            //             }, {
            //                 "key": 'phone_number',
            //                 'label': 'Phone Number'
            //             },{
            //                 "key": 'doctor_name',
            //                 'label': 'Doctor Name'
            //             }, {
            //                 "key": 'department_name',
            //                 'label': 'Department Name'
            //             }, {
            //                 "key": 'admission_date',
            //                 'label': 'Admission Date'
            //             }, {
            //                 "key": '77',
            //                 'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '77_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '78',
            //                 'label': 'Current Insurance Card/Policy Copy'
            //             }, {
            //                 "key": '78_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '79',
            //                 'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //             }, {
            //                 "key": '79_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '80',
            //                 'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //             }, {
            //                 "key": '80_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '81',
            //                 'label': 'Employee ID Card (For Corporate Policies)'
            //             }, {
            //                 "key": '81_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '82',
            //                 'label': 'Current OP Investigation Reports'
            //             }, {
            //                 "key": '82_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '83',
            //                 'label': 'Current OP Prescription Signed By Doctor'
            //             }, {
            //                 "key": '83_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '84',
            //                 'label': 'Past Investigation Reports'
            //             }, {
            //                 "key": '84_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '85',
            //                 'label': 'Previous Discharge Summary (If Applicable)'
            //             }, {
            //                 "key": '85_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '86',
            //                 'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //             }, {
            //                 "key": '86_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '87',
            //                 'label': 'Passport Size Photo Of Policy Holder'
            //             }, {
            //                 "key": '87_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '88',
            //                 'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //             }, {
            //                 "key": '88_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '89',
            //                 'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //             }, {
            //                 "key": '89_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '90',
            //                 'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //             }, {
            //                 "key": '90_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '91',
            //                 'label': 'MLC/FIR (If Applicable)'
            //             }, {
            //                 "key": '91_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '92',
            //                 'label': 'KYC Form (Issued By Hospital)'
            //             }, {
            //                 "key": '92_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '93',
            //                 'label': 'Initial Assessment Form (If Applicable)'
            //             }, {
            //                 "key": '93_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '94',
            //                 'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //             }, {
            //                 "key": '94_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             }, {
            //                 "key": '95',
            //                 'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //             }, {
            //                 "key": '95_uploaded_date',
            //                 'label': 'Uploaded Date'
            //             },{
            //                 "key": '1st_document_upload _time',
            //                 'label': '1st document upload time'
            //             },
            //             {
            //                 "key": 'last_document_upload_time',
            //                 'label': ' last document upload time'
            //             },{
            //                 "key": 'rn_preauth_requested_time',
            //                 'label': 'Pre-Auth Requested Time'
            //             }
            //         ]
            //         break; 
            //     case 'UN14':
            //             tableHead = [
            //                 {
            //                     "key": 'ip_no',
            //                     'label': 'IP Number'
            //                 }, {
            //                     "key": 'umr_no',
            //                     'label': 'UMR Number'
            //                 }, {
            //                     "key": 'patient_name',
            //                     'label': 'Patient Name'
            //                 }, {
            //                     "key": 'phone_number',
            //                     'label': 'Phone Number'
            //                 },{
            //                     "key": 'doctor_name',
            //                     'label': 'Doctor Name'
            //                 }, {
            //                     "key": 'department_name',
            //                     'label': 'Department Name'
            //                 }, {
            //                     "key": 'admission_date',
            //                     'label': 'Admission Date'
            //                 }, {
            //                     "key": '96',
            //                     'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //                 }, {
            //                     "key": '96_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '97',
            //                     'label': 'Current Insurance Card/Policy Copy'
            //                 }, {
            //                     "key": '97_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '98',
            //                     'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
            //                 }, {
            //                     "key": '98_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '99',
            //                     'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
            //                 }, {
            //                     "key": '99_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '100',
            //                     'label': 'Employee ID Card (For Corporate Policies)'
            //                 }, {
            //                     "key": '100_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '101',
            //                     'label': 'Current OP Investigation Reports'
            //                 }, {
            //                     "key": '101_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '102',
            //                     'label': 'Current OP Prescription Signed By Doctor'
            //                 }, {
            //                     "key": '102_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '103',
            //                     'label': 'Past Investigation Reports'
            //                 }, {
            //                     "key": '103_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '104',
            //                     'label': 'Previous Discharge Summary (If Applicable)'
            //                 }, {
            //                     "key": '104_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '105',
            //                     'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
            //                 }, {
            //                     "key": '105_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '106',
            //                     'label': 'Passport Size Photo Of Policy Holder'
            //                 }, {
            //                     "key": '106_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '107',
            //                     'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
            //                 }, {
            //                     "key": '107_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '108',
            //                     'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
            //                 }, {
            //                     "key": '108_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '109',
            //                     'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
            //                 }, {
            //                     "key": '109_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '110',
            //                     'label': 'MLC/FIR (If Applicable)'
            //                 }, {
            //                     "key": '110_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '111',
            //                     'label': 'KYC Form (Issued By Hospital)'
            //                 }, {
            //                     "key": '111_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '112',
            //                     'label': 'Initial Assessment Form (If Applicable)'
            //                 }, {
            //                     "key": '112_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '113',
            //                     'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
            //                 }, {
            //                     "key": '113_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 }, {
            //                     "key": '114',
            //                     'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
            //                 }, {
            //                     "key": '114_uploaded_date',
            //                     'label': 'Uploaded Date'
            //                 },{
            //                     "key": '1st_document_upload _time',
            //                     'label': '1st document upload time'
            //                 },
            //                 {
            //                     "key": 'last_document_upload_time',
            //                     'label': ' last document upload time'
            //                 },{
            //                     "key": 'rn_preauth_requested_time',
            //                     'label': 'Pre-Auth Requested Time'
            //                 }
            //             ]
            //             break;                      
            //     default:
            //         break;    
            // }
            switch (unit) {
                case 'UN0':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '1',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '1_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '2',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '2_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '3',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '3_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '4',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '4_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '5',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '5_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '6',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '6_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '7',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '7_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '8',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '8_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '9',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '9_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '10',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '10_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '11',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '11_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '12',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '12_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '13',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '13_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '14',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '14_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '15',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '15_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '16',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '16_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '17',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '17_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '18',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '18_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '19',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '19_uploaded_date',
                            'label': 'Uploaded Date'
                        },
                        {
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },
                        {
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN1': 
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '1',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '1_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '2',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '2_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '3',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '3_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '4',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '4_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '5',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '5_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '6',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '6_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '7',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '7_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '8',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '8_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '9',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '9_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '10',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '10_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '11',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '11_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '12',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '12_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '13',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '13_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '14',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '14_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '15',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '15_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '16',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '16_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '17',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '17_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '18',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '18_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '19',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '19_uploaded_date',
                            'label': 'Uploaded Date'
                        },
                        {
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },
                        {
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN2':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        }, {
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        },{
                            "key": '20',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '20_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '21',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '21_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '22',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '22_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '23',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '23_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '24',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '24_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '25',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '25_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '26',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '26_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '27',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '27_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '28',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '28_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '29',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '29_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '30',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '30_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '31',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '31_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '32',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '32_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '33',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '33_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '34',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '34_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '35',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '35_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '36',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '36_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '37',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '37_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '38',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '38_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN3':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        },{
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '39',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '39_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '40',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '40_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '41',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '41_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '42',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '42_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '43',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '43_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '44',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '44_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '45',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '45_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '46',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '46_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '47',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '47_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '48',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '48_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '49',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '49_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '50',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '50_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '51',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '51_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '52',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '52_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '53',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '53_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '54',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '54_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '55',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '55_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '56',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '56_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '57',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '57_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;
                case 'UN11':
                        tableHead = [
                            {
                                "key": 'ip_no',
                                'label': 'IP Number'
                            }, {
                                "key": 'umr_no',
                                'label': 'UMR Number'
                            }, {
                                "key": 'patient_name',
                                'label': 'Patient Name'
                            }, {
                                "key": 'phone_number',
                                'label': 'Phone Number'
                            },{
                                "key": 'doctor_name',
                                'label': 'Doctor Name'
                            }, {
                                "key": 'department_name',
                                'label': 'Department Name'
                            }, {
                                "key": 'admission_date',
                                'label': 'Admission Date'
                            }, {
                                "key": '58',
                                'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                            }, {
                                "key": '58_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '59',
                                'label': 'Current Insurance Card/Policy Copy'
                            }, {
                                "key": '59_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '60',
                                'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                            }, {
                                "key": '60_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '61',
                                'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                            }, {
                                "key": '61_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '62',
                                'label': 'Employee ID Card (For Corporate Policies)'
                            }, {
                                "key": '62_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '63',
                                'label': 'Current OP Investigation Reports'
                            }, {
                                "key": '63_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '64',
                                'label': 'Current OP Prescription Signed By Doctor'
                            }, {
                                "key": '64_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '65',
                                'label': 'Past Investigation Reports'
                            }, {
                                "key": '65_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '66',
                                'label': 'Previous Discharge Summary (If Applicable)'
                            }, {
                                "key": '66_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '67',
                                'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                            }, {
                                "key": '67_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '68',
                                'label': 'Passport Size Photo Of Policy Holder'
                            }, {
                                "key": '68_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '69',
                                'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                            }, {
                                "key": '69_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '70',
                                'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                            }, {
                                "key": '70_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '71',
                                'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                            }, {
                                "key": '71_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '72',
                                'label': 'MLC/FIR (If Applicable)'
                            }, {
                                "key": '72_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '73',
                                'label': 'KYC Form (Issued By Hospital)'
                            }, {
                                "key": '73_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '74',
                                'label': 'Initial Assessment Form (If Applicable)'
                            }, {
                                "key": '74_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '75',
                                'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                            }, {
                                "key": '75_uploaded_date',
                                'label': 'Uploaded Date'
                            }, {
                                "key": '76',
                                'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                            }, {
                                "key": '76_uploaded_date',
                                'label': 'Uploaded Date'
                            },{
                                "key": '1st_document_upload _time',
                                'label': '1st document upload time'
                            },
                            {
                                "key": 'last_document_upload_time',
                                'label': ' last document upload time'
                            },{
                                "key": 'rn_preauth_requested_time',
                                'label': 'Pre-Auth Requested Time'
                            }
                        ]
                        break; 
                case 'UN10':
                            tableHead = [
                                {
                                    "key": 'ip_no',
                                    'label': 'IP Number'
                                }, {
                                    "key": 'umr_no',
                                    'label': 'UMR Number'
                                }, {
                                    "key": 'patient_name',
                                    'label': 'Patient Name'
                                }, {
                                    "key": 'phone_number',
                                    'label': 'Phone Number'
                                },{
                                    "key": 'doctor_name',
                                    'label': 'Doctor Name'
                                }, {
                                    "key": 'department_name',
                                    'label': 'Department Name'
                                }, {
                                    "key": 'admission_date',
                                    'label': 'Admission Date'
                                }, {
                                    "key": '77',
                                    'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                }, {
                                    "key": '77_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '78',
                                    'label': 'Current Insurance Card/Policy Copy'
                                }, {
                                    "key": '78_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '79',
                                    'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                                }, {
                                    "key": '79_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '80',
                                    'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                }, {
                                    "key": '80_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '81',
                                    'label': 'Employee ID Card (For Corporate Policies)'
                                }, {
                                    "key": '81_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '82',
                                    'label': 'Current OP Investigation Reports'
                                }, {
                                    "key": '82_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '83',
                                    'label': 'Current OP Prescription Signed By Doctor'
                                }, {
                                    "key": '83_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '84',
                                    'label': 'Past Investigation Reports'
                                }, {
                                    "key": '84_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '85',
                                    'label': 'Previous Discharge Summary (If Applicable)'
                                }, {
                                    "key": '85_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '86',
                                    'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                                }, {
                                    "key": '86_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '87',
                                    'label': 'Passport Size Photo Of Policy Holder'
                                }, {
                                    "key": '87_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '88',
                                    'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                                }, {
                                    "key": '88_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '89',
                                    'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                                }, {
                                    "key": '89_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '90',
                                    'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                                }, {
                                    "key": '90_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '91',
                                    'label': 'MLC/FIR (If Applicable)'
                                }, {
                                    "key": '91_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '92',
                                    'label': 'KYC Form (Issued By Hospital)'
                                }, {
                                    "key": '92_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '93',
                                    'label': 'Initial Assessment Form (If Applicable)'
                                }, {
                                    "key": '93_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '94',
                                    'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                                }, {
                                    "key": '94_uploaded_date',
                                    'label': 'Uploaded Date'
                                }, {
                                    "key": '95',
                                    'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                                }, {
                                    "key": '95_uploaded_date',
                                    'label': 'Uploaded Date'
                                },{
                                    "key": '1st_document_upload _time',
                                    'label': '1st document upload time'
                                },
                                {
                                    "key": 'last_document_upload_time',
                                    'label': ' last document upload time'
                                },{
                                    "key": 'rn_preauth_requested_time',
                                    'label': 'Pre-Auth Requested Time'
                                }
                            ]
                            break;  
                case 'UN14':
                    tableHead = [
                                    {
                                        "key": 'ip_no',
                                        'label': 'IP Number'
                                    }, {
                                        "key": 'umr_no',
                                        'label': 'UMR Number'
                                    }, {
                                        "key": 'patient_name',
                                        'label': 'Patient Name'
                                    }, {
                                        "key": 'phone_number',
                                        'label': 'Phone Number'
                                    },{
                                        "key": 'doctor_name',
                                        'label': 'Doctor Name'
                                    }, {
                                        "key": 'department_name',
                                        'label': 'Department Name'
                                    }, {
                                        "key": 'admission_date',
                                        'label': 'Admission Date'
                                    }, {
                                        "key": '96',
                                        'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                    }, {
                                        "key": '96_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '97',
                                        'label': 'Current Insurance Card/Policy Copy'
                                    }, {
                                        "key": '97_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '98',
                                        'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                                    }, {
                                        "key": '98_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '99',
                                        'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                                    }, {
                                        "key": '99_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '100',
                                        'label': 'Employee ID Card (For Corporate Policies)'
                                    }, {
                                        "key": '100_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '101',
                                        'label': 'Current OP Investigation Reports'
                                    }, {
                                        "key": '101_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '102',
                                        'label': 'Current OP Prescription Signed By Doctor'
                                    }, {
                                        "key": '102_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '103',
                                        'label': 'Past Investigation Reports'
                                    }, {
                                        "key": '103_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '104',
                                        'label': 'Previous Discharge Summary (If Applicable)'
                                    }, {
                                        "key": '104_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '105',
                                        'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                                    }, {
                                        "key": '105_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '106',
                                        'label': 'Passport Size Photo Of Policy Holder'
                                    }, {
                                        "key": '106_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '107',
                                        'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                                    }, {
                                        "key": '107_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '108',
                                        'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                                    }, {
                                        "key": '108_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '109',
                                        'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                                    }, {
                                        "key": '109_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '110',
                                        'label': 'MLC/FIR (If Applicable)'
                                    }, {
                                        "key": '110_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '111',
                                        'label': 'KYC Form (Issued By Hospital)'
                                    }, {
                                        "key": '111_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '112',
                                        'label': 'Initial Assessment Form (If Applicable)'
                                    }, {
                                        "key": '112_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '113',
                                        'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                                    }, {
                                        "key": '113_uploaded_date',
                                        'label': 'Uploaded Date'
                                    }, {
                                        "key": '114',
                                        'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                                    }, {
                                        "key": '114_uploaded_date',
                                        'label': 'Uploaded Date'
                                    },{
                                        "key": '1st_document_upload _time',
                                        'label': '1st document upload time'
                                    },
                                    {
                                        "key": 'last_document_upload_time',
                                        'label': ' last document upload time'
                                    },{
                                        "key": 'rn_preauth_requested_time',
                                        'label': 'Pre-Auth Requested Time'
                                    }
                                ]
                                break;  
                case 'UN4':
                    tableHead = [
                        {
                            "key": 'ip_no',
                            'label': 'IP Number'
                        }, {
                            "key": 'umr_no',
                            'label': 'UMR Number'
                        }, {
                            "key": 'patient_name',
                            'label': 'Patient Name'
                        }, {
                            "key": 'phone_number',
                            'label': 'Phone Number'
                        },{
                            "key": 'doctor_name',
                            'label': 'Doctor Name'
                        }, {
                            "key": 'department_name',
                            'label': 'Department Name'
                        }, {
                            "key": 'admission_date',
                            'label': 'Admission Date'
                        }, {
                            "key": '96',
                            'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '96_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '97',
                            'label': 'Current Insurance Card/Policy Copy'
                        }, {
                            "key": '97_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '98',
                            'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                        }, {
                            "key": '98_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '99',
                            'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                        }, {
                            "key": '99_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '100',
                            'label': 'Employee ID Card (For Corporate Policies)'
                        }, {
                            "key": '100_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '101',
                            'label': 'Current OP Investigation Reports'
                        }, {
                            "key": '101_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '102',
                            'label': 'Current OP Prescription Signed By Doctor'
                        }, {
                            "key": '102_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '103',
                            'label': 'Past Investigation Reports'
                        }, {
                            "key": '103_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '104',
                            'label': 'Previous Discharge Summary (If Applicable)'
                        }, {
                            "key": '104_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '105',
                            'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                        }, {
                            "key": '105_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '106',
                            'label': 'Passport Size Photo Of Policy Holder'
                        }, {
                            "key": '106_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '107',
                            'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                        }, {
                            "key": '107_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '108',
                            'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                        }, {
                            "key": '108_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '109',
                            'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                        }, {
                            "key": '109_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '110',
                            'label': 'MLC/FIR (If Applicable)'
                        }, {
                            "key": '110_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '111',
                            'label': 'KYC Form (Issued By Hospital)'
                        }, {
                            "key": '111_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '112',
                            'label': 'Initial Assessment Form (If Applicable)'
                        }, {
                            "key": '112_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '113',
                            'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                        }, {
                            "key": '113_uploaded_date',
                            'label': 'Uploaded Date'
                        }, {
                            "key": '114',
                            'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                        }, {
                            "key": '114_uploaded_date',
                            'label': 'Uploaded Date'
                        },{
                            "key": '1st_document_upload _time',
                            'label': '1st document upload time'
                        },
                        {
                            "key": 'last_document_upload_time',
                            'label': ' last document upload time'
                        },{
                            "key": 'rn_preauth_requested_time',
                            'label': 'Pre-Auth Requested Time'
                        }
                    ]
                    break;  
                case 'UN9': 
                tableHead = [
                    {
                        "key": 'ip_no',
                        'label': 'IP Number'
                    }, {
                        "key": 'umr_no',
                        'label': 'UMR Number'
                    }, {
                        "key": 'patient_name',
                        'label': 'Patient Name'
                    }, {
                        "key": 'phone_number',
                        'label': 'Phone Number'
                    },{
                        "key": 'doctor_name',
                        'label': 'Doctor Name'
                    }, {
                        "key": 'department_name',
                        'label': 'Department Name'
                    }, {
                        "key": 'admission_date',
                        'label': 'Admission Date'
                    }, {
                        "key": '96',
                        'label': 'Govt Issued ID Card Of The Patient (Aadhar, PAN, Voter ID, Passport, Driving License)'
                    }, {
                        "key": '96_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '97',
                        'label': 'Current Insurance Card/Policy Copy'
                    }, {
                        "key": '97_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '98',
                        'label': 'Previous/Inactive Insurance Card/Policy Copy (If Applicable)'
                    }, {
                        "key": '98_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '99',
                        'label': 'Govt Issued ID Of Policy Holder (If Patient & Policy Holder Are Different) (Aadhar, PAN, Voter ID, Passport, Driving License)'
                    }, {
                        "key": '99_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '100',
                        'label': 'Employee ID Card (For Corporate Policies)'
                    }, {
                        "key": '100_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '101',
                        'label': 'Current OP Investigation Reports'
                    }, {
                        "key": '101_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '102',
                        'label': 'Current OP Prescription Signed By Doctor'
                    }, {
                        "key": '102_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '103',
                        'label': 'Past Investigation Reports'
                    }, {
                        "key": '103_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '104',
                        'label': 'Previous Discharge Summary (If Applicable)'
                    }, {
                        "key": '104_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '105',
                        'label': 'Current Address Proof Of Policy Holder (Must Be Same As Insurance Policy) (Aadhar, Voter ID, Passport, Driving License), Any Utility Bill, Phone Bill)'
                    }, {
                        "key": '105_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '106',
                        'label': 'Passport Size Photo Of Policy Holder'
                    }, {
                        "key": '106_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '107',
                        'label': 'Past History-Patient Declaration & DMO Endorsement Letters (If Applicable)'
                    }, {
                        "key": '107_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '108',
                        'label': 'Patient Declaration Of Self-Injury, Fall Etc. (If Applicable)'
                    }, {
                        "key": '108_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '109',
                        'label': 'Patient Declaration Of Diabetes & Hypertension (If Applicable)'
                    }, {
                        "key": '109_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '110',
                        'label': 'MLC/FIR (If Applicable)'
                    }, {
                        "key": '110_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '111',
                        'label': 'KYC Form (Issued By Hospital)'
                    }, {
                        "key": '111_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '112',
                        'label': 'Initial Assessment Form (If Applicable)'
                    }, {
                        "key": '112_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '113',
                        'label': 'Filled Pre Auth Form (Signed By Doctor And Patient/Attendant)'
                    }, {
                        "key": '113_uploaded_date',
                        'label': 'Uploaded Date'
                    }, {
                        "key": '114',
                        'label': 'GIPSA Declaration Form Signed By Patient/Attendant'
                    }, {
                        "key": '114_uploaded_date',
                        'label': 'Uploaded Date'
                    },{
                        "key": '1st_document_upload _time',
                        'label': '1st document upload time'
                    },
                    {
                        "key": 'last_document_upload_time',
                        'label': ' last document upload time'
                    },{
                        "key": 'rn_preauth_requested_time',
                        'label': 'Pre-Auth Requested Time'
                    }
                ]
                break;                           
                default:
                    break;    
            }
            switch (slug) {
                case 'documents-report':
                    This.setState((state) => ({ thead: tableHead, filename: 'Documents-Report.csv', download_btn: true, downloadStatus: 0, loadding: true }), () => {
                        postService(getDocumentsReport, 'POST', {
                            "data": {
                                "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                                "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                                "export": 1,
                                "page_no": 0
                            }
                        }).then(res => {
                            console.log('tat report:', res.data);
                            if (res.status) {
                                res.data.map((data, key) => {
                                    let dateArray=[];
                                    Object.keys(data).map((dataKey) => {
                                        if (dataKey === 'uploaded_date'  || dataKey === 'admission_date') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm:ss').toString() : ''
                                        }
                                        else {
                                            res.data[key][dataKey] = ((res.data[key][dataKey])) ? res.data[key][dataKey] : ''
                                        }
                                        if (dataKey === 'rn_preauth_requested_time') {
                                            res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm:ss'): ''
                                        }
                                        if(dataKey!=='counselling_id' && res.data[key][dataKey]!==null && dataKey!=='admission_date' && dataKey!=='rn_preauth_requested_time'){
                                            let x = new Date(res.data[key][dataKey]);
                                            if (x instanceof Date && !isNaN(x)) {
                                                dateArray.push(res.data[key][dataKey]);
                                                if(dateArray.length>0)
                                                    {
                                                        const minDate = dateArray.reduce((acc,date)=>{return acc&&new Date(acc)<new Date(date)?acc:date},'')
                                                      const maxDate = dateArray.reduce((acc,date)=>{return acc&&new Date(acc)>new Date(date)?acc:date},'')
                                                       res.data[key]['1st_document_upload _time']=minDate?moment(minDate).format('YYYY-MM-DD HH:mm:ss'):null;
                                                       res.data[key]['last_document_upload_time']=maxDate?moment(maxDate).format('YYYY-MM-DD HH:mm:ss'):null;
                                                    }
                                            }
                                        }
                                    })
                                })
                                This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false, }));
                                this.csvLink.current.link.click()
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops! something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });
                    break;
                default:
                    break;    
            }
        } catch (error) {
            console.log(error);
        }
    }
    render() {
        let { totalItemsCount, formData, downloadtbody, downloadStatus, tableTitle, thead, data, tbody, filename, download_btn, select2, search, activePage } = this.state;
        let { slug } = this.props.match.params;
        return (
            <div>
                <div className="clearfix">
                    {
                        download_btn
                            ?
                            downloadStatus && tbody != ''
                                ?
                                <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                                    <button className="btn btn-success text-capitalize float-left" onClick={() => { this.downloadFile() }}>
                                        <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span>
                                    </button>
                                    <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                </div>
                                :
                                <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                                    <Button className="btn btn-success-disabled text-capitalize float-left" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                                </div>
                            :
                            <div className="mt-5" />
                    }
                </div>
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="float-left pt-1">
                                    {tableTitle}
                                </div>
                                <div className="row">
                                    {formData
                                        .map((feild, key) => {
                                            {
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <div className="col-4">
                                                            {
                                                                select2
                                                                    ?
                                                                    <div className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Select2
                                                                            selectdata={feild}
                                                                            // changedObj={this.state.changedObj}
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            // Queuedata={this.state.formData}
                                                                            onselectChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>

                                                    )
                                                }
                                            }
                                            if (feild.element === 'input') {
                                                return (
                                                    <div className="">
                                                        {
                                                            search
                                                                ?
                                                                <div className="d-flex mx-auto" style={{ 'position': 'absolute', 'left': '370px' }}>
                                                                    <div
                                                                        className={`${feild.className
                                                                            ? feild.className
                                                                            : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Inputlayer
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            feildData={feild}
                                                                            onInputChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                        <div class="input-group-append">
                                                                            {/* <Button type="primary" onClick={this.search} loading={this.state.loadding}><img src="/assets/images/icons/search.png"></img></Button> */}
                                                                            <button class="btn btn-primary btn-sm" onClick={this.search}><img src={homepage+"/assets/images/icons/search.png"} /></button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                )
                                            }

                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}

                                                        <DateRange
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                </div>
                            </div>

                        </div>

                        <div className="financial-table table-responsive sticky-header" id={slug !== 'idle-reports' ? 'table' : null}>
                            <table className="table table-hover table-bordered mb-0 bg-white" style={{ width: '470%' }}>
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">S.No.</td>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key}>
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        if (head['label'] === `Uploaded Date` || head['label'] === 'Admission Date') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '-'}</td>)
                                                        }
                                                        if (head['label'] === 'Patient Name' || head['label'] === 'UMR Number' || head['label'] === 'IP Number' || head['label'] === 'Phone Number' || head['label'] === 'Doctor Name' || head['label'] === 'Department Name') {
                                                            return <td className="text-capitalize">{(body[head['key']]) ? body[head['key']] : '-'}</td>
                                                        }
                                                        if (head['label'] === 'Pre-Auth Requested Time') {
                                                            return <td className="text-capitalize">{(body[head['key']]) ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '-'}</td>
                                                        }
                                                        return (
                                                            <td className="text-capitalize">{(body[head['key']]) ? body[head['key']] : 'NO'}</td>
                                                        )
                                                    })
                                                    }

                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="13" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                        </div>
                    </div>

                </Spin>
            </div>
        )
    }
}

export default Documents_Report;